import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { TopNav } from '../Navigation/TopNav';
import { Footer } from './Footer';
import { GlobalSearch } from '../GlobalSearch/GlobalSearch';
import { NewsletterCta } from '../shared';

export const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();

  // Deep links to "#newsletter" (e.g. shared URLs, the nav's fallback) scroll
  // to the box once it's mounted, wherever the route landed.
  useEffect(() => {
    if (location.hash === '#newsletter') {
      document.getElementById('newsletter')?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location]);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', display: 'flex', flexDirection: 'column' }}>
      <GlobalSearch />
      <TopNav />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          px: { xs: 2, sm: 3 },
          py: { xs: 2, sm: 3 },
        }}
      >
        <Box sx={{ maxWidth: 1280, mx: 'auto', width: '100%' }}>
          {children}
          <NewsletterCta />
        </Box>
      </Box>

      <Footer />
    </Box>
  );
};
